import OrderDetails from "../symbols/orderDetails";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export interface CollectBookingFee {
  CreditUsage?: number;
  PayAsYouGoPrice?: number;
}
export interface CollectPricing {
  Delivery: number;
  BookingFee?: CollectBookingFee;
  PremiumFee?: number;
  Vat: number;
  Total: number;
  TaxRate: number;
  DistanceInMiles?: number;
}

export interface CourierPriceResult {
  Min: CollectPricing;
  Max: CollectPricing;
}

export type ICourierServiceType = "regular" | "direct";

export interface ICourierVehicleType {
  Code: string;
  Name: string;
}

function OrderDetailsReducer(state = initialState, action: any) {
  switch (action.type) {
    case OrderDetails.ORDER_DETAILS:
      return { ...state, loading: true, error: false };
    case OrderDetails.ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case OrderDetails.ORDER_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case OrderDetails.CLEAR_ORDER_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default OrderDetailsReducer;
